import { ICommentEditableOps, IMentionUserInfo } from './type';

/**
 * 转换信息为富文本可识别数据，同时抽取at用户信息
 * @param {*} content 储存的映射关系数据
 * @param {*} commentUserInfo 用户at信息
 */
export const formatEditorContent = (
    content: string | ICommentEditableOps[],
    commentUserInfo: {
        [key: string]: IMentionUserInfo;
    },
) => {
    try {
        const data = typeof content === 'string' ? JSON.parse(content) : content;
        const defaultValue = data.reduce((
            content: ICommentEditableOps[],
            item: {
                data: IMentionUserInfo;
                text: string;
            },
        ) => {
            if (item.data) {
                const { mentionId, avatar } = item.data;
                commentUserInfo[mentionId] = item.data;
                content?.push({
                    insert: {
                        mention: item.text,
                    },
                    attributes: {
                        id: mentionId.toString(),
                        'data-avatar': avatar,
                    },
                }, {
                    insert: '\uFEFF', // 这里是因为需要添加一个光标占位符，否则会有输入文字失焦的情况
                });
                return content;
            }
            content?.push({
                insert: item.text,
            });
            return content;
        }, []);
        return defaultValue;
    } catch (e) {
        // 兼容旧的纯文本批注
        return [{ insert: content }];
    }
};
